export default __webpack_public_path__ + "static/media/P545MANB2.24d661a8.pdf";